<template>
  <div class="alter-teacher">
    <div class="alter-find">
      <input type="text" placeholder="搜索" v-model="findInfo" >
    </div>
    <NOdata v-if="this.AllList.length == 0" title="未查询信息"></NOdata>
    <template v-else>
      <div class="alter-item" v-for="(item,index) in AllList" :key="index" @click="select(item)">
        <div>
          <h4>{{item.text}}</h4>
        </div>
      </div>
    </template>
    <div class="alter-buttons">
      <button class="clear" @click="clear()">取消</button>
    </div>
  </div>
</template>
<script>
import iApi from '@/utils/internship'
export default {
  props: {
    isRadio:{
      type:Boolean,
      default:false
    },
    list:{
      type:Array,
      default:() => []
    }
  },
  data(){
    return{
      AllList:[],
      type:'1',
      findInfo:''
    }
  },
  created(){
    this.teaTap()
  },
  watch:{
    findInfo: {
      handler(n) {
        let arr = this.list.filter(field => field.text.indexOf(n) > -1)
        this.AllList = arr;
      }
    }
  },
  methods:{
    select(item){
      let data = {
        text: item.text,
        id:item.id
      }
      this.$emit('closePop',data)
    },
    clear(){
      this.$emit('closePop',false)
    },
    async teaTap(){
      let arr = this.list.filter(field => field.text.indexOf(this.findInfo) > -1)
      this.AllList = arr;
    }
  },
  computed:{
  },     
}
</script>
<style lang="less">
.van-popup.van-popup--bottom {
    border-radius: 5px 5px 0 0 !important;
    max-height: 50% !important;
    min-height: 50% !important;
}
.alter-teacher{
  padding: 0 20px;
  margin: 20px 0 20px;
  .alter-find{
    border-radius:3px;
    background-color: @attendance-background-color-6;
    padding: 11px 13px;display: flex;
    i{
      background: url(../../../../assets/images/search.png)no-repeat center;
      background-size: 22px 22px;width: 22px;height: 22px;
    }
    input{
      color: @attendance-color-2;
      padding: 0 11px;flex: 1;
      &::placeholder{
        color: @attendance-color-2;
      }
    }
  }
  .alter-item{
    padding: 10px 0px 0px 20px;
    background-color: @attendance-background-color-10;
    border-radius:5px;margin: 21px 0 13px;
    display: flex;justify-content: space-between;align-items: center;
    h4{
      color: @attendance-color-1;font-size: 16px;line-height: 22px;margin-bottom: 8px;
    }
    p{
      color: @attendance-color-2;font-size: 12px;line-height: 17px;
    }
    /deep/.el-checkbox__inner{
      width: 18px;height: 18px;
      border-radius: 50%;
      border: 2px solid @attendance-border-color-4;
      &::after{
        left: 5px;top: 2px;border-width: 2px;
      }
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
      background: @attendance-background-color-1;
      border-color:@attendance-background-color-1;
    }
  }
  .alter-buttons{
    z-index: 9;
    background-color: @attendance-color-3;
    position: fixed;bottom: 0;padding: 20px 0;
    width: calc(~"100% - 40px");box-sizing: border-box;
    display: flex;justify-content: space-between;align-items: center;
    button{
      width: calc(~"50% - 10px");padding: 11px 0;border-radius: 3px;
    }
    button.clear{
      background-color: @attendance-background-color-7;
      color: @attendance-background-color-1;
      width: 100%;
    }
    button.confirm{
      background-color: @attendance-background-color-1;
      color: @attendance-color-3;
    }
  }
}
</style>






















// WEBPACK FOOTER //
// src/components/newPages/student/internship/findPopup.vue